import React, { FC } from 'react';

import { useSkippableFragments } from '../../hooks/use-skippable-fragments';
import { useCurrentSkippableFragment } from '../../../feature-player/hooks/skin/use-current-skippable-fragment';
import { RecapSkipButtonGroupContainer } from '../../../feature-player/ui/skin/recap-skip-button-group/container';
import { CompoundCreditSkipButtonGroupContainer } from '../../../feature-player/ui/skin/compound-credit-skip-button-group/container';
import { NextEpisodeSkipButtonGroupContainer } from '../../../feature-player/ui/skin/next-episode-skip-button-group/container';
import { PrerollSkipButtonGroupContainer } from '../../../feature-player/ui/skin/preroll-skip-button-group/container';

import { EpisodeIntroSkipButtonGroupContainerWithFilter } from './EpisodeIntroSkipButtonGroupContainerWithFilter';

interface EpisodeSkipControlsContainerProps {
    contentId: string;
    className?: string;
}

export const EpisodeSkipControlsContainer: FC<EpisodeSkipControlsContainerProps> = ({
    contentId,
    className,
}) => {
    const skippableFragments = useSkippableFragments(contentId);
    const currentFragment = useCurrentSkippableFragment(skippableFragments);

    return (
        <>
            <PrerollSkipButtonGroupContainer
                currentFragment={currentFragment}
                className={className}
            />
            <EpisodeIntroSkipButtonGroupContainerWithFilter
                contentId={contentId}
                currentFragment={currentFragment}
                className={className}
            />
            <RecapSkipButtonGroupContainer
                currentFragment={currentFragment}
                className={className}
            />
            <CompoundCreditSkipButtonGroupContainer
                currentFragment={currentFragment}
                className={className}
            />
            <NextEpisodeSkipButtonGroupContainer
                contentId={contentId}
                currentFragment={currentFragment}
                className={className}
            />
        </>
    );
};
